module.exports = __webpack_public_path__ + "static/media/deliveryVan_navy.74e2cd23.svg";